import React, { useState, useEffect } from "react";
import { client }                       from "./SanityClient";
import JobPosting                       from "./JobPosting";
import "./JobFilter.css";

export default function JobApp() {
  const [jobs, setJobs]                   = useState([]);
  const [filteredJobs, setFilteredJobs]   = useState([]);
  const [specOptions, setSpecOptions]     = useState([]);

  const [keyword, setKeyword]             = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [category, setCategory]           = useState("");

  useEffect(() => {
    client
      .fetch(
        `*[_type == "job"]{
           _id,
           title,
           location,
           specialization
         }`
      )
      .then(data => {
        setJobs(data);
        setFilteredJobs(data);
        const allSpecs = data.flatMap(j => j.specialization || []);
        const uniqueSpecs = Array.from(
          new Set(allSpecs.map(s => s.trim()))
        ).sort();
        setSpecOptions(uniqueSpecs);
      })
      .catch(err => console.error("Sanity fetch error:", err));
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const kw  = keyword.trim().toLowerCase();
    const loc = locationFilter.trim().toLowerCase();
    const cat = category;

    const results = jobs.filter(job => {
      const matchKW =
        !kw ||
        job.title.toLowerCase().includes(kw) ||
        (job.specialization || []).some(spec =>
          spec.toLowerCase().includes(kw)
        );

      const matchLoc =
        !loc ||
        job.location.toLowerCase().includes(loc);

      const matchCat =
        !cat ||
        (job.specialization || []).some(spec =>
          spec.toLowerCase().includes(cat.toLowerCase())
        );

      return matchKW && matchLoc && matchCat;
    });

    setFilteredJobs(results);
  };

  const handleReset = () => {
    setKeyword("");
    setLocationFilter("");
    setCategory("");
    setFilteredJobs(jobs);
  };

  return (
    <div className="job-app-container">
      <section className="our-commitment">
        <h2>Our Commitment</h2>
        <p>
          At DEI, we are more than just a traditional MEP, civil/structural, or architectural firm. We are a
        fully integrated and in-house team of registered professionals. Our team includes architects, civil,
        structural, mechanical, and electrical engineers. By offering all major disciplines under one roof,
        we can streamline coordination across teams, enhance communication, and increase efficiency
        when providing complex and intelligent engineering solutions.
        </p>
        <p>
          For over 40 years, DEI has provided comprehensive architectural and engineering (AE) services
        to WSSC and numerous other federal and local agencies. Our work for WSSC has included
        architectural, structural, mechanical, electrical, and plumbing design services. Beyond WSSC,
        DEI has served as a Prime on multiple contracts for the U.S. Army Corps of Engineers and U.S.
        Postal Service, consistently delivering successful outcomes and maintaining long-term
        relationships with clients.
        </p>
        <p>
          As a certified small minority-owned firm, DEI brings four decades of proven experience in
        delivering multi-discipline services and solutions.
        </p>
      </section>

      <form className="job-search-form" onSubmit={handleSearch}>
        <div className="search-group">
          <input
            type="search"
            placeholder="Search by title or specialization"
            value={keyword}
            onChange={e => setKeyword(e.target.value)}
          />
        </div>

        <div className="search-group">
          <input
            type="text"
            placeholder="Location"
            value={locationFilter}
            onChange={e => setLocationFilter(e.target.value)}
          />
        </div>

        <div className="search-group">
          <select
            value={category}
            onChange={e => setCategory(e.target.value)}
          >
            <option value="">All Specializations</option>
            {specOptions.map(spec => (
              <option key={spec} value={spec}>
                {spec}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="search-btn">
          Search
        </button>
        <button
          type="button"
          className="reset-btn"
          onClick={handleReset}
        >
          Reset
        </button>
      </form>

      <JobPosting jobs={filteredJobs} />
    </div>
  );
}
